import type { HeroTwoMapperData, ImageField, LinkField, MapperButtonLabel, RichTextField } from '@/types/prismicMappers'

export const getHeading = (type: string, uid: string, data: HeroTwoMapperData): RichTextField | undefined => {
  if (uid === 'cmmc' || uid === 'compliance-platform') {
    return data.title
  }

  switch (type) {
    case 'featureHero':
      return data.feature_title
    case 'product':
    case 'framework':
      return data.product_title
    case 'customers':
      return data.page_title
    case 'careers':
    case 'contact':
      return data.page_heading
    case 'frameworks-glossary-details':
      return data.title
    default:
      return data.hero_heading
  }
}

export const getDescription = (type: string, uid: string, data: HeroTwoMapperData): RichTextField | undefined => {
  if (uid === 'cmmc' || uid === 'compliance-platform') {
    return data.description
  }

  switch (type) {
    case 'featureHero':
      return data.feature_description
    case 'product':
    case 'framework':
      return data.product_description
    case 'careers':
    case 'customers':
      return data.page_description
    case 'contact':
      return data.description
    case 'frameworks-glossary-details':
      return data.summary
    default:
      return data.hero_description
  }
}

export const getHeroBtnLink = (type: string, uid: string, data: HeroTwoMapperData): LinkField | undefined => {
  if (uid === 'cmmc' || uid === 'compliance-platform') {
    return data.hero_btn_link
  }

  switch (type) {
    case 'product':
    case 'framework':
    case 'featureHero':
      return data.demo_button_link
    case 'hipaa':
      return data.button_url
    case 'frameworks-glossary-details':
      return data.btn_link
    default:
      return data.hero_btn_link
  }
}

export const getHeroBtnLabel = (type: string, uid: string, data: HeroTwoMapperData): MapperButtonLabel => {
  if (uid === 'cmmc' || uid === 'compliance-platform') {
    return data.hero_btn_link?.text
  }

  switch (type) {
    case 'product':
    case 'featureHero':
      return data.demo_button_text
    case 'hipaa':
      return data.button_text
    case 'frameworks-glossary-details':
      return data.btn_label
    default:
      return data.hero_btn_label
  }
}

export const getHeroImage = (type: string, uid: string, data: HeroTwoMapperData): ImageField | undefined => {
  if (uid === 'cmmc' || uid === 'compliance-platform') {
    return data.hero_image
  }

  switch (type) {
    case 'careers':
      return data.header_image_new
    case 'contact':
      return data.page_header_image
    case 'frameworks-glossary-details':
      return data.logo
    default:
      return data.hero_image
  }
}
